// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2xLU3","right":"styles_right__HP0fG"};